"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlayerTypes = void 0;
var VideoPlayerTypes;
(function (VideoPlayerTypes) {
    VideoPlayerTypes["YOUTUBE"] = "YOUTUBE";
    VideoPlayerTypes["VIMEO"] = "VIMEO";
    VideoPlayerTypes["NATIVE"] = "NATIVE";
})(VideoPlayerTypes || (exports.VideoPlayerTypes = VideoPlayerTypes = {}));
//# sourceMappingURL=VideoEnums.js.map